import { Adapter as t, getAdapter as a } from "../../../../adapter.js";
import { StampProgrammeApplicationRuleAdapter as r } from "./stampProgrammeApplicationRule/stampProgrammeApplicationRule.adapter.js";
import { StampProgrammeSettingsModel as o } from "./stampProgrammeSettigns.model.js";
import { StampProgrammeBalanceAdapter as p } from "./stampProgrammeSettingsBalance/stampProgrammeSettingsBalance.adapter.js";
class c extends t {
  adapt(e) {
    return new o({
      applicationRules: (e.application_rules ?? []).map(a(r).adapt),
      productCatalogMode: e.product_catalog_mode,
      balance: a(p).adapt(e.balance)
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  c as StampProgrammeSettingsAdapter
};
//# sourceMappingURL=stampProgrammeSettigns.adapter.js.map
